import { contactData } from '@/mocks/anime';

export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            {contactData.title}
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            欢迎与51动漫网取得联系
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-50 rounded-2xl border border-background-200/60 p-8 md:p-10 text-center">
            <div className="w-16 h-16 mx-auto mb-5 bg-accent-100 rounded-2xl flex items-center justify-center">
              <i className="ri-mail-send-line text-accent-600 text-2xl"></i>
            </div>
            <h3 className="font-heading text-xl font-bold text-foreground-950 mb-4">
              投稿与合作咨询
            </h3>
            <p className="text-foreground-600 text-sm leading-relaxed mb-6 max-w-lg mx-auto">
              {contactData.desc}
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
              <div className="flex items-center gap-2 text-foreground-700">
                <div className="w-9 h-9 flex items-center justify-center">
                  <i className="ri-mail-line text-primary-500 text-xl"></i>
                </div>
                <span className="text-sm font-medium">{contactData.email}</span>
              </div>
              <div className="flex items-center gap-2 text-foreground-700">
                <div className="w-9 h-9 flex items-center justify-center">
                  <i className="ri-qq-line text-primary-500 text-xl"></i>
                </div>
                <span className="text-sm font-medium">QQ群: {contactData.qq}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}